import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Typography,
    styled,
} from "@mui/material";
import { useState, useEffect } from "react";
import Paper, { PaperProps } from "@mui/material/Paper";
import Draggable from "react-draggable";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useUtilityContext } from "../../utility-provider";
import  { setDeficiencyComment } from "../../features/deficiencyCommentSlice";
import {
    callApi,
    initCommentData,
    deficiencyCommentDetail,
} from "../subPage/DeficiencyComment/DeficiencyCommentFunction";
import { LOCAL_CONSTANT } from "../Const";
import { setColumnLogicName } from "../Common";

export interface InputProps {
    props: {
        userType: string;
        modalOpen: boolean;
        setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
        CommentTextFieldObj: any;
        tableName: string;
        columnName: string;
        subKey: string;
        handleCommentChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, labelName: string) => void;
        handleSaveComment: (labelName: string) => Promise<void>;
    };
}

//スタイル
//不備コメントモーダル画面を移動
function PaperComponent(props: PaperProps) {
    return (
        <Draggable
            handle="#draggable-dialog-title" //ドラック可能
            cancel={'[class*="MuiDialogContent-root"]'} //ドラックを無効
        >
            <Paper {...props} />
        </Draggable>
    );
}
//不備コメントモーダルの背景を透明
const CustomDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiBackdrop-root": {
        backgroundColor: "transparent",
    },
}));
//登録ボタン
const RegistButton = styled(Button)({
    backgroundColor: "#00CC5B",
    color: "white",
    "&: hover": {
        backgroundColor: "#29e17a",
    },
});
//キャンセルボタン
const CancelButton = styled(Button)({
    backgroundColor: "#ffffff00",
    color: "#f00",
    border: "1px solid #f00",
});

export const DeficiencyCommentRegModal: React.FC<InputProps> = ({ props }) => {
    const utilityCtx = useUtilityContext();
    const dispatch = useAppDispatch();
    //候補地NOと枝を取得
    const objLongPageParam = useAppSelector((state) => state.longPage.param);
    //不備コメント一覧
    const listDeficiencyComment = useAppSelector((state) => state.deficiencyComment);
    //不備コメントリロード
    const [reload, setReload] = useState<boolean>(false);

    //モーダルクローズ
    const handleModalClose = () => {
        props.setModalOpen(false);
    };
    
    //登録
    const handleRegist = async () => {
        props.setModalOpen(false);
        await props.handleSaveComment(props.columnName);
        //不備コメントリロード
        setReload(true);
    };

    //登録後に不備コメント一覧を取得
    useEffect(() => {
        if (reload) {
            deficiencyCommentRelaod();
        }
    }, [reload]);

    //不備コメント一覧を取得関数
    const deficiencyCommentRelaod = () => {
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        try {
            callApi("getDeficiencyComment", objLongPageParam.planAreaId, objLongPageParam.branch).then((res: any) => {
                if (res.length > 0) {
                    dispatch(setDeficiencyComment(initCommentData(res)));
                }
            });
            setReload(false);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        } catch (e) {
            console.log(e);
            setReload(false);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        }
    }

    // 項目ごとの不備コメント
    const deficiencyComments = deficiencyCommentDetail(listDeficiencyComment, props.tableName, props.columnName, props.subKey);

    return (
        <Box>
            {/*不備コメント モーダル画面 */}
            <Draggable>
                <CustomDialog
                    open={props.modalOpen}
                    onClose={handleModalClose}
                    PaperComponent={PaperComponent} //PaperComponentをモーダル全体をドラック可能
                    aria-labelledby="draggable-dialog-title"
                    fullWidth
                >
                    <DialogTitle
                        style={{ cursor: "move" }} //スタイルを追加し、カーソルを変更しドラック可能
                        id="draggable-dialog-title"
                    >
                        不備コメント {setColumnLogicName(props.tableName, props.columnName)}
                    </DialogTitle>
                    <DialogContent>
                        <Box>
                            {deficiencyComments.length !== 0 && (
                                <Box mb={2}>
                                    <Typography>登録済み不備コメント</Typography>
                                    {deficiencyComments.map((deficiencyComment:any, index: number) => (
                                        <TextField
                                            key={index}
                                            fullWidth
                                            variant="filled"
                                            value={deficiencyComment.comment}
                                            multiline
                                            InputProps={{
                                                readOnly: true,
                                                style: {
                                                    padding: "16px 12px", // 上下左右のパディングを設定
                                                },
                                            }}
                                        />
                                    ))}
                                </Box>
                            )}
                        </Box>
                        {/* RRの場合、新規で不備コメントを登録 */}
                        {props.userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                            <Box>
                                <Typography>新規登録不備コメント</Typography> 
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    value={props.CommentTextFieldObj[props.columnName]}
                                    multiline
                                    onChange={(e) => props.handleCommentChange(e, props.columnName)}
                                />
                            </Box>
                        )}
                        <DialogActions sx={{ justifyContent: "space-around" }}>
                            <CancelButton onClick={handleModalClose}>
                                {LOCAL_CONSTANT.LABEL.CANCEL}
                            </CancelButton>
                            {/* RRの場合、登録ボタンを表示 */}
                            {props.userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                <RegistButton onClick={() => handleRegist()}>{LOCAL_CONSTANT.LABEL.REGIST_LABEL}</RegistButton>
                            )}
                        </DialogActions>
                    </DialogContent>
                </CustomDialog>
            </Draggable>
        </Box>
    );
};

export default DeficiencyCommentRegModal;
